import storage from "good-storage";
// token
const USER_TOKEN_KEY = "__usertoken__";
// db登录账号的用户名
const DB_USER_REAL_NAME = "__dbUserRealName__";
// 用户权限
const USER_OPERATION_AUTHORITY = "__userOperationAuthority__"
// 效期历史记录
const VALID_DATE_HISLIST = "__validDateHislist__"
// 运营搜索字段

function getToken() {
  // console.log('取token--', storage.get(USER_TOKEN_KEY))
  return storage.get(USER_TOKEN_KEY);
}

function saveToken(val) {
  // console.log('存token--')
  storage.set(USER_TOKEN_KEY, val);
}

function deleteToken() {
  // console.log('删除token--')
  storage.remove(USER_TOKEN_KEY);
}
function saveDBUserRealName(val) {
  storage.set(DB_USER_REAL_NAME, val);
}
function getDBUserRealName() {
  return storage.get(DB_USER_REAL_NAME);
}

// 保存收费登记--退货服务中效期输入历史记录
function saveValidDateHislist(val) {
  storage.set(VALID_DATE_HISLIST, JSON.stringify(val));
}
// 获取收费登记--退货服务中效期输入历史记录
function getValidDateHislist() {
  if (storage.get(VALID_DATE_HISLIST)) {
    return JSON.parse(storage.get(VALID_DATE_HISLIST))
  } else {
    return []
  }
}

export {
  getToken,
  saveToken,
  deleteToken,
  saveDBUserRealName,
  getDBUserRealName,
  saveValidDateHislist,
  getValidDateHislist,
};
